// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2LsUY","inner":"Footer_inner__2Ju-U","nextIcon":"Footer_nextIcon__vpeY_","innerLeft":"Footer_innerLeft__2RiLc"};